export default class ListCache<T> {
    constructor(date: string = '', items: T[] = []) {
        this.date = date
        this.items = items
    }
    date: string
    items: T[]
}
